import { getDomain } from "tldts";

export const getPlatformNameFromUrl = (url: string) => {
	try {
		const hostname = new URL(url).hostname.replace(/^www\./, "").toLowerCase();
		const matchesDomain = (domain: string) => hostname === domain || hostname.endsWith(`.${domain}`);

		if (matchesDomain("instagram.com")) return "Instagram";
		if (matchesDomain("tiktok.com")) return "TikTok";
		if (
			matchesDomain("facebook.com") ||
			matchesDomain("fb.watch") ||
			matchesDomain("fb.com") ||
			matchesDomain("fb.gg") ||
			matchesDomain("fb.me")
		)
			return "Facebook";
		if (matchesDomain("youtube.com") || matchesDomain("youtu.be")) return "YouTube";
		if (matchesDomain("twitter.com") || matchesDomain("x.com")) return "X";
		if (matchesDomain("linkedin.com")) return "LinkedIn";
		if (matchesDomain("pinterest.com")) return "Pinterest";
		if (matchesDomain("snapchat.com")) return "Snapchat";
		if (matchesDomain("twitch.tv")) return "Twitch";

		const registrableDomain = getDomain(hostname);
		if (!registrableDomain) return "Link";

		const [rootDomain] = registrableDomain.split(".");
		if (!rootDomain) return "Link";

		return rootDomain.charAt(0).toUpperCase() + rootDomain.slice(1);
	} catch {
		return "Link";
	}
};
